import { render, staticRenderFns } from "./TsoftSelectOrder.vue?vue&type=template&id=3ff05742"
import script from "./TsoftSelectOrder.vue?vue&type=script&lang=js"
export * from "./TsoftSelectOrder.vue?vue&type=script&lang=js"
import style0 from "./TsoftSelectOrder.vue?vue&type=style&index=0&id=3ff05742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports